import axios from 'axios';
import { serialize } from 'object-to-formdata';

export default {
    PRODUCTTYPE_ONLY_INACTIVE: 0,
    PRODUCTTYPE_ONLY_ACTIVE: 1,
    PRODUCTTYPE_ACTIVE_AND_INACTIVE: 2,
    getProductTypes(activitySetting, onBackground = false, includeImages = true) {
        const config = onBackground ? { isBackground: true } : undefined;
        return axios.post(
            '/producttype/getProductTypes/',
            { activitySetting, includeImages },
            config
        );
    },
    duplicate(id, key, name) {
        return axios.post('/producttype/duplicate', { id, key, name });
    },
    listGroups() {
        return axios.post('/producttype/listGroups/');
    },
    listSubgroups() {
        return axios.post('/producttype/listSubgroups/');
    },
    fetchStandardDescriptionPlaceholders() {
        return axios.post('/producttype/fetchStandardDescriptionPlaceholders/');
    },
    updateProductionDays(
        prodDaysDefaultColor,
        prodDaysNonDefaultColor,
        productionMinutes,
        productTypeId
    ) {
        return axios.post('/producttype/updateProductionDaysForProducttype/', {
            prodDaysDefaultColor,
            prodDaysNonDefaultColor,
            productionMinutes,
            producttype: productTypeId,
        });
    },
    productTypeDetails(productTypeId, orderId, onBackground = false) {
        const config = onBackground ? { isBackground: true } : undefined;
        return axios.post(
            '/producttype/producttypeDetails/',
            {
                producttypeId: productTypeId,
                orderId: orderId || undefined,
            },
            config
        );
    },
    getAllProductTypesDetails(productTypeIds, onBackground = false) {
        const config = onBackground ? { isBackground: true } : undefined;
        return axios.post(
            '/producttype/getAllProductTypesDetails/',
            { producttypeIds: productTypeIds },
            config
        );
    },
    uploadProductTypeImage(file) {
        const formData = new FormData();
        formData.append('category', 'product-types');
        formData.append('file', file);
        return axios.post('[API]/files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    deleteProductTypeImage(imagePath) {
        return axios.delete('[API]/files/product-types/' + imagePath);
    },
    uploadDataFieldOptionImage(file) {
        // Sand a form post request to the server
        const formData = new FormData();
        formData.append('category', 'data-field-options');
        formData.append('file', file);
        return axios.post('[API]/files', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    deleteDataFieldOptionImage(imagePath) {
        return axios.delete('[API]/files/data-field-options/' + imagePath);
    },
    deleteMultipleDataFieldOptionImages(imagePaths) {
        const query = imagePaths
            .map((imagePath) => 'files[]=' + imagePath)
            .join('&');

        return axios.delete('[API]/files/data-field-options/delete-multiple?' + query);
    },
    updateDatafield(payload) {
        return axios.post('/producttype/updateDatafield/', payload);
    },
    newDatafield(payload) {
        return axios.post('/producttype/newDatafield/', payload);
    },
    fetchDataFields(productTypeId) {
        return axios.post('/producttype/datafields/', {
            producttype: productTypeId,
        });
    },
    removeDataField(dataFieldId) {
        return axios.post('/producttype/removeDataField/', { dataFieldId });
    },
    getDataTypes() {
        return axios.post('/producttype/getDataTypes/');
    },
    fetchForEdit(productTypeId) {
        return axios.post('/producttype/editGet/', {
            producttype: productTypeId,
        });
    },
    fethDataFieldForEdit(dataFieldId) {
        return axios.post('/producttype/getDataFieldForEdit/', { dataFieldId });
    },
    createType(payload) {
        return axios.post('/producttype/add/', payload);
    },
    updateType(payload) {
        return axios.post('/producttype/update/', payload);
    },
    fetchCustomImageOptions() {
        return axios.post('/producttype/fetchCustomImageOptions/');
    },
    fetchAvailableForWorkstation(workstationId) {
        return axios.post('/producttype/fetchAvailableForWorkstation/', {
            workstationId,
        });
    },
    fetchSawlines(productTypeId) {
        return axios.post('/producttype/sawlines/', {
            productType: productTypeId,
        });
    },
    fetchDatafieldValidationRules(productTypeId) {
        return axios.get('[API]/product-type/fetch/' + productTypeId);
    },
    fetchProductTypes() {
        return axios.get('[API]/product-type/list');
    },
    updateDatafieldValidationRules(productTypeId, datafieldValidationRules) {
        return axios.put('[API]/product-type/update', {
            id: productTypeId,
            datafieldValidationRules,
        });
    },
};
